/**
 * Partner Embed Redux Store
 *
 * Uses the shared slices from configurator-ui-shared.
 */

import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';

import { accordionSlice, apiSlice, itemSlice } from 'configurator-ui-shared';

import { localCartSlice } from './localCartSlice';
import { multiProductSlice } from './multiProductSlice';

export const partnerStore = configureStore({
  reducer: {
    accordion: accordionSlice.reducer,
    item: itemSlice.reducer,
    localCart: localCartSlice.reducer,
    multiProduct: multiProductSlice.reducer,
    [apiSlice.reducerPath]: apiSlice.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(apiSlice.middleware)
});

export type RootState = ReturnType<typeof partnerStore.getState>;
export type PartnerDispatch = typeof partnerStore.dispatch;

// Typed hooks
export const usePartnerDispatch: () => PartnerDispatch = useDispatch;
export const usePartnerSelector: TypedUseSelectorHook<RootState> = useSelector;

// Re-export as configurator hooks for compatibility with shared components
export const useConfiguratorDispatch = usePartnerDispatch;
export const useRootSelector = usePartnerSelector;

// Multi-product selectors (defined here to avoid circular imports with multiProductSlice)
export const selectProducts = (state: RootState) => state.multiProduct.products;
export const selectActiveProductTag = (state: RootState) =>
  state.multiProduct.activeProductTag;
export const selectActiveProduct = (state: RootState) =>
  state.multiProduct.products.find(
    p => p.productTag === state.multiProduct.activeProductTag
  ) ?? null;
